import { render } from "./ImpactWithTabs.vue?vue&type=template&id=ed561904"
import script from "./ImpactWithTabs.vue?vue&type=script&lang=js"
export * from "./ImpactWithTabs.vue?vue&type=script&lang=js"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__